var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highway-input1',_vm._b({attrs:{"type":"regulate"},on:{"change":_vm.onChange}},'highway-input1',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }